import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface";
@Component({
  selector: "app-labelImage",
  template: `
<div [formGroup]="group">
    <label class="labelPadrao" (click)="field.onClick()" [ngStyle]="field.style()">
      <img [src]="field.icon" style="cursor:pointer"/> &nbsp; {{field.label}}
    </label>
</div>
`,
  styles: []
})
export class LabelImageComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;

  constructor() { }
  ngOnInit() { }
}